// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".user-form .el-avatar[data-v-e407d332]{--el-avatar-bg-color:#e9e5df}", "",{"version":3,"sources":["webpack://./resources/js/components/user/UserForm.vue"],"names":[],"mappings":"AACE,uCACE,4BAAJ","sourcesContent":["\n  .user-form .el-avatar {\n    --el-avatar-bg-color: #E9E5DF;\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
